export const generatePassword = (options = {}) => {
  const { length = 8,
    numbers = true,
    symbols = false,
    uppercase = true,
    strict = true } = options

  const lower = 'abcdefghijklmnopqrstuvwxyz'
  const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const digits = '0123456789'
  const symbolChars = '!@#$%^&*()_+[]{}|;:,.<>?'

  let chars = lower
  if (uppercase) {
    chars += upper
  }
  if (numbers) {
    chars += digits
  }
  if (symbols) {
    chars += symbolChars
  }

  const getRandomChar = value => {
    return value[Math.floor(Math.random() * value.length)]
  }

  let result = ''
  while (result.length < length) {
    result += getRandomChar(chars)
  }

  if (strict) {
    const checks = []
    if (numbers) {
      checks.push(digits)
    }
    if (symbols) {
      checks.push(symbolChars)
    }
    if (uppercase) {
      checks.push(upper)
    }
    checks.forEach(set => {
      if (!result.split('').some(char => {
        return set.includes(char)
      })) {
        const position = Math.floor(Math.random() * result.length)
        const symbols = result.split('')
        symbols[position] = getRandomChar(set)
        result = symbols.join('')
      }
    })
  }

  return result
}
